@if (applicationData?.content) {
  <div class="c__argument col-20 col-l-16">
    <div class="c__content">
      <sd-rich-paragraph [contentData]="applicationData?.content"
        [brand]="brand"
        [textConfig]="applicationData?.content?.heading?.textConfig"
        [isDescription]="applicationData?.content?.heading?.isDescription"
        [titleLevel]="applicationData?.content?.heading?.titleLevel"
        (clicked)="clicked($event)"
      />
    </div>
    @if (applicationData) {
      <div class="c__vertical-layout {{customClass}} {{ applicationData?.title ? '' : 'has-no-title'}}">
        @if (applicationData?.title) {
          <sd-title [titleLevel]="applicationData?.titleLevel">
            {{ applicationData?.title}}
          </sd-title>
        }
        @if (applicationData?.image) {
          <sd-banner [media]="applicationData?.image"
            [isAriaHidden]="true"
            [isFit]="true"
            [twicPicsAutoSize]="twicPicsAutoSize"
          />
        }
      </div>
    }
    @if (applicationData?.mainMedia) {
      <sd-banner class="c__fullImage"
        [media]="applicationData?.mainMedia"
        [isAriaHidden]="true"
        [twicPicsAutoSize]="twicPicsAutoSize"
      />
    }
  </div>
}
